<template>
    <div class="center">
        <Card class="card">
            <template #title>
                EPD CNMP Platfrom
            </template>
            <template #content>
                <div class="formgrid grid" style="width:100%">
                    <i v-if="approved" class="pi pi-check-circle col-12 md:col-4"
                        style="font-size: 8rem;color:green"></i>
                    <i v-else class="pi pi-times-circle col-12 md:col-4" style="font-size: 8rem;"></i>
                    <div class="col-12 md:col-8">
                        <h1>{{ message }}</h1>
                        <label style="font-size:1.2rem">You may now <a href="#" style="color:grey">close</a> the
                            window.</label>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="footer">
                    <img class="col-12 md:col-4" src="img/logo_EPD_color.png" alt="logo_EPD" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
export default {
    name: 'ApproveView',
    data() {
        return {
            message: "123",
            approved: true
        }
    },
    mounted() {
        console.log(this.$route.query.result)
        switch (this.$route.query.result) {
            case "1":
                this.message = "User approved.";
                this.approved = true;
                break;
            case "2":
                this.message = "User has been approved by someone else.";
                this.approved = true;
                break;
            case "3":
                this.message = "User rejected.";
                this.approved = false;
                break;
            case "4":
                this.message = "User has been rejected by someone else.";
                this.approved = false;
                break;
            case "5":
                this.message = "Account activated.";
                this.approved = true;
                break;
        }
    }
}
</script>

<style scoped>
.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.card {
    width: 430px;
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
}
</style>